import { useConfigurationStore } from '@stores'
import { useMemo } from 'react'
import { translate } from '@amusnet/translations'

export const useAutoplaySettingsButtons = () => {
    const autoplayOptions = useConfigurationStore((state) => state.autoplayOptions)

    const buttons = useMemo(() => {
        return autoplayOptions.map((ao) => {
            return {
                label: translate('gameui.spins'),
                spinsAmount: ao === -1 ? '∞' : ao.toString(),
            }
        })
    }, [autoplayOptions])

    return { buttons, autoplayOptions }
}
